var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('router-view',{key:_vm.$route.path}),_c('br')],1):_c('Loader')}
var staticRenderFns = []

export { render, staticRenderFns }